'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './post.routes';

export class ForumPostComponent {
  constructor(ForumService, $state, $stateParams, Auth, $location, $anchorScroll,
              textAngularManager, $timeout, $uibModal, dialogs, StorageService, Config) {
    'ngInject';

    this.isAdmin = Auth.isAdminSync;
    this.userId = Auth.getCurrentUserSync()._id;
    this.baseContainerClass = Config.getPlatformConfig().getBaseContainerClass();
    this.ForumService = ForumService;
    this.StorageService = StorageService;
    this.postId = $stateParams.id;
    this.cat = $stateParams.cat;
    this.Auth = Auth;
    this.$state = $state;

    this.$location = $location;
    this.$anchorScroll = $anchorScroll;
    this.$timeout = $timeout;
    this.textAngularManager = textAngularManager;

    this.$uibModal = $uibModal;
    this.dialogs = dialogs;

    this.galleryHook = {};

    this.message = {
      contents: '',
      attachments: [],
      meta: {
        creationUser: this.userId
      }
    };

    this.toolbarDefinition = [
      ["bold","italics","underline","strikeThrough"],
      ["p","pre","quote","clear"],
      ["ul","ol"],
      ["undo","redo"],
      ["insertLink"]
    ];

    this.reloadData();
  }

  isCreator(data) {
    return data.meta.creationUser == this.userId;
  }

  reloadData() {
    this.ForumService.get({id: this.postId}, data => {
      this.post = data;

      if (this.post.attachments && this.post.attachments.length){
        this.galleryImages = this.post.attachments.filter(attachment => {
          return this.isImageMime(attachment.contentType);
        });

        this.galleryImages = this.galleryImages.map(function(obj){
          var rObj = {};

          rObj.title = obj.filename;
          rObj.alt = obj.filename;
          rObj.url = "/api/storage/" + obj._id;
          rObj.thumbUrl = '/api/storage/' + obj._id + '/thumb';

          return rObj;
        });
      }

      this.post.messages.forEach(message => {
        if (message.attachments && message.attachments.length){

          this.galleryHook[message._id] = message.attachments.filter(attachment => {
            return this.isImageMime(attachment.contentType);
          });

          this.galleryHook[message._id] = this.galleryHook[message._id].map(function(obj){
            var rObj = {};

            rObj.title = obj.filename;
            rObj.alt = obj.filename;
            rObj.url = "/api/storage/" + obj._id;
            rObj.thumbUrl = '/api/storage/' + obj._id + '/thumb';

            return rObj;
          });
        }
      })
    }, err => {
      console.log('Could not retrieve forum post from server');
    });
  }

  create(form) {
    this.ForumService.createMessage({id: this.postId}, this.message, (newMessage) => {
      this.message.contents = '';
      this.message.attachments = [];
      this.reloadData();
    });
  }

  quote(user, msgToQuote) {
    let name = user && user.shortName ? user.shortName : 'Unknown';
    this.message.contents += name + " wrote:<blockquote>" + msgToQuote + "</blockquote><br/><p></p>";

    this.$location.hash('editor');
    this.$anchorScroll();

    var editorScope = this.textAngularManager.retrieveEditor('editor').scope;
    this.$timeout(() => {
      editorScope.displayElements.text.trigger('focus');
    });
  }

  editMessage(message) {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'postEditor',
      backdrop: 'static', // Prevents the modal to close, when clicking in the background
      resolve: {
        config: function() {
          return {
            message: angular.copy(message)
          }
        }
      },
      size: 'lg'
    });

    modalInstance.result.then(
      function (editedMessage) {
        editedMessage.meta.changeUser = that.Auth.getCurrentUserSync()._id;
        that.ForumService.updateMessage({id: that.postId, msgid: editedMessage._id}, editedMessage, () => {
          that.reloadData();
        }, err => {
          console.error(err);
        });
      },
      function () { /* cancel */ }
    );

  }

  editPost() {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'postEditor',
      backdrop: 'static', // Prevents the modal to close, when clicking in the background
      resolve: {
        config: function() {
          return {
            post: angular.copy(that.post)
          }
        }
      },
      size: 'lg'
    });

    modalInstance.result.then(
      function (editedPost) {
        that.ForumService.update({id: that.postId}, {
          title: editedPost.title,
          contents: editedPost.contents,
          attachments: editedPost.attachments
        }, () => {
          that.reloadData();
        }, err => {
          console.error(err);
        });
      },
      function () { /* cancel */ }
    );

  }

  deletePost() {
    var that = this;

    var dlg = this.dialogs.confirm("Delete Forum Post?", "Do you really want to delete this post?<br/>The post and all its comments will be deleted!");
    dlg.result.then(() => {
      // OK delete it
      that.ForumService.delete({id: that.postId},
        () => {
          that.$location.url("/forum/"+that.cat);
        },
        err => {
          alert("Could not delete forum board post");
        });
    }, () => {
      // Cancel
    });
  }

  deleteMessage(message) {
    var that = this;

    var dlg = this.dialogs.confirm("Delete Comment?", "Do you really want to delete the comment?");
    dlg.result.then(() => {
      // OK delete it
      that.ForumService.deleteMessage({id: that.postId, msgid: message._id},
        () => {
          that.reloadData();
        },
        err => {
          alert("Could not delete forum board post");
        });
    }, () => {
      // Cancel
    });
  }

  removeAsset(idx) {
    this.message.attachments.splice(idx,1);
  }

  isImageMime(mime) {
    return mime.startsWith('image/');
  }

  isPdfMime(mime) {
    return mime === 'application/pdf';
  }

  openAssetBrowserModal() {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'assetBrowser',
      resolve: {
        config: function() {
          return {
            restrictToUserAssets: !that.Auth.isAdminSync(),
            userId: that.Auth.getCurrentUserSync()._id
          }
        }
      },
      size: 'lg'
    });

    modalInstance.result.then(
      function (newlySelectedAssets) {
        that.message.attachments = that.message.attachments.concat(newlySelectedAssets);
      },
      function () { /* cancel */ }
    );

  }

  openAssetUploadModal = function () {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'assetUpload',
      resolve: {
        config: function() {
          return {
            acceptedFileTypes: 'application/pdf,image/*'
          }
        }
      }
    });

    modalInstance.result.then(
      function (result) {

        result.forEach(storageId => {
          that.StorageService.getMeta({id: storageId}, data => {
            that.message.attachments.push(data);
          }, err => {
            console.log('could not retrieved storage from server');
          });

        });

      },
      function () { /* cancel */ }
    );

  }

}

export default angular.module('conduuApp.forumPost', [uiRouter])
  .config(routes)
  .component('forumPost', {
    template: require('./post.html'),
    controller: ForumPostComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/forum/post/post.component.js